import { createNavigation } from 'next-intl/navigation';
import { ComponentProps } from 'react';

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation({});

export type LinkProps = ComponentProps<typeof Link>;
